import { ReactElement } from "react";
import { Link, useSearchParams } from "react-router-dom";

interface SecondmentsPagerProps {
  page: number;
  pageCount: number;
}

export default function SecondmentsPager({ page, pageCount }: SecondmentsPagerProps): ReactElement | null {
  const [params] = useSearchParams();
  if (pageCount <= 1) {
    return null;
  }
  const start = pageCount <= 5 ? 1 : Math.max(1, Math.min(page - 2, pageCount - 4));
  const end = Math.min(pageCount, start + 4);
  const pages: number[] = [];
  for (let number = start; number <= end; number += 1) {
    pages.push(number);
  }

  function href(nextPage: number): string {
    const next = new URLSearchParams(params);
    next.set("action", "search");
    next.delete("t");
    if (nextPage <= 1) {
      next.delete("page");
    } else {
      next.set("page", String(nextPage));
    }
    return `/secondments?${next.toString()}#search`;
  }

  return (
    <nav className="secondments-pager" aria-label="Pagination">
      {page > 2 && pageCount > 5 ? <Link to={href(1)} title="First Page">«</Link> : null}
      {page > 1 && pageCount > 5 ? <Link to={href(page - 1)} title="Previous Page">‹</Link> : null}
      {pages.map((number) => (
        number === page
          ? <span key={number} className="is-current">{number}</span>
          : <Link key={number} to={href(number)}>{number}</Link>
      ))}
      {page < pageCount && pageCount > 5 ? <Link to={href(page + 1)} title="Next Page">›</Link> : null}
      {page + 3 < pageCount ? <Link to={href(pageCount)} title="Last Page">»</Link> : null}
    </nav>
  );
}
